import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import eventFormReducer from '../reducers/eventFormReducer';

const configureStore = (railsProps) => (
  createStore(eventFormReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
